import styled from "styled-components";
import HeaderBackground from "../../../../assets/images/nmdfc_header.svg";

export const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 22000;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: ${({ $isScrolled }) =>
    $isScrolled ? "transparent" : ""};
  isolation: isolate;
  overflow: visible;
  align-self: stretch;
  transform: translateZ(0);
  backface-visibility: hidden;
  transition: background-color 0.2s ease;

  /* Enlarged/short viewports need the header to scroll with the document. */
  @media (max-width: 1280px), (max-height: 600px) {
    position: relative;
  }
`;

export const HeaderWrapper = styled.header`
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  min-height: ${({ $compact }) => ($compact ? "36px" : "42px")};
  height: auto;
  background: #005f5b;
  position: relative;
  z-index: 3;
  overflow: visible;
`;

export const GovernmentBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 6px;
  max-width: 1800px;
  min-height: ${({ $compact }) => ($compact ? "36px" : "42px")};
  height: auto;
  margin: 0 auto;
  padding: ${({ $compact }) => ($compact ? "4px 22px" : "5px 24px")};
  position: relative;
  z-index: 2;
  color: #ffffff;
  font-size: 11px;
  line-height: 1;
  white-space: nowrap;

  > div {
    min-width: 0;
  }

  > div:last-child {
    margin-left: auto;
  }

  img {
    height: ${({ $compact }) => ($compact ? "20px" : "22px")};
    width: auto;
  }

  button {
    min-width: 20px;
    height: 20px;
    border-radius: 3px;
    padding: 0 4px;
    font-size: 11px;
    line-height: 1;
  }

  > div:first-child {
    gap: ${({ $compact }) => ($compact ? "16px" : "40px")};
  }

  > div:last-child {
    gap: ${({ $compact }) => ($compact ? "14px" : "32px")};
  }

  > div > div {
    gap: ${({ $compact }) => ($compact ? "8px" : "16px")};
  }

  .h-8 {
    height: ${({ $compact }) => ($compact ? "24px" : "2rem")};
  }

  .text-sm {
    font-size: ${({ $compact }) => ($compact ? "11px" : "0.875rem")};
  }

  .topbar-link-button {
    min-width: auto;
    height: auto;
    border: 0;
    border-radius: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font-weight: 600;
    padding: 0;
  }

  .topbar-link-button:hover,
  .topbar-link-button[aria-pressed="true"] {
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .topbar-link-button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    text-decoration: none;
  }

  .topbar-actions {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    min-width: 0;
    flex-wrap: wrap;
    justify-content: flex-end;
    column-gap: ${({ $compact }) => ($compact ? "10px" : "18px")};
    row-gap: 7px;
    margin-left: 0 !important;
    white-space: normal;
  }

  .topbar-language-selector {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    min-width: auto;
    height: auto;
    border: 0;
    border-radius: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font: inherit;
    padding: 0;
  }

  .topbar-language-icon {
    position: relative;
    display: inline-block;
    width: ${({ $compact }) => ($compact ? "18px" : "21px")};
    height: ${({ $compact }) => ($compact ? "16px" : "18px")};
    line-height: 1;
    color: #ffffff;
  }

  .topbar-language-devanagari {
    position: absolute;
    left: 0;
    top: ${({ $compact }) => ($compact ? "1px" : "2px")};
    font-size: ${({ $compact }) => ($compact ? "10px" : "12px")};
    font-weight: 700;
  }

  .topbar-language-english {
    position: absolute;
    left: ${({ $compact }) => ($compact ? "8px" : "10px")};
    top: ${({ $compact }) => ($compact ? "4px" : "5px")};
    font-size: ${({ $compact }) => ($compact ? "11px" : "13px")};
    font-weight: 700;
  }

  @media (max-width: 900px) {
    padding: 6px 12px;
    min-height: 0;
    font-size: clamp(9px, 2.2vw, 11px);
    line-height: 1.2;
    white-space: normal;

    > div:first-child {
      width: 100%;
      flex: 1 1 100%;
      justify-content: center;
      column-gap: 8px;
      row-gap: 7px;
    }

    > div:first-child > div:first-child {
      gap: 5px;
    }

    button {
      font-size: inherit;
    }

    .topbar-actions {
      justify-content: center;
      column-gap: 8px;
      row-gap: 7px;
    }

    .topbar-link-button,
    .topbar-language-selector {
      font-size: inherit;
      line-height: 1.25;
    }

    .topbar-skip-link {
      max-width: 145px;
      white-space: normal;
      text-align: center;
    }

    .topbar-divider {
      height: 16px !important;
      flex: 0 0 1px;
    }
  }

  @media (max-width: 420px) {
    padding: 6px 8px;

    > div:first-child {
      width: 100%;
      justify-content: center;
      column-gap: 6px;
      row-gap: 6px;
    }

    .topbar-actions {
      column-gap: 6px;
      row-gap: 6px;
    }

    .topbar-skip-link {
      max-width: 125px;
    }
  }
`;

export const NavbarRow = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  height: ${({ $compact }) =>
    $compact
      ? "clamp(118px, calc(4.5vw + 46px), 140px)"
      : "clamp(128px, calc(5.5vw + 46px), 148px)"};

  background-color: ${({ $embedded, $compact }) =>
    $compact ? "transparent" : $embedded ? "transparent" : "#fff8ea"};
  background-image: ${({ $embedded, $compact }) =>
    $compact || $embedded
      ? "none"
      : `url(${HeaderBackground}), linear-gradient(90deg, #ffffff 0%, #fffaf0 100%)`};
  background-repeat: no-repeat, no-repeat;
  background-position:
    center calc(0px - 5vw),
    center;
  background-size:
    calc(100% + 96px) auto,
    100% 100%;

  overflow: visible;
  z-index: 2;

  ${({ $compact }) =>
    $compact &&
    `
      align-items: flex-end;
      justify-content: center;
      gap: 0;
      padding: 0;
    `}



  @media (max-width: 768px) {
    background-position: center top;
    background-size: calc(100% + 96px) auto;
  }

  @media (max-width: 900px) {
    margin-bottom: 0;
    height: auto;
    min-height: 128px;
    padding: 8px 12px;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
    background-color: #fff8ea;
    background-image:
      radial-gradient(circle at 72% 5%, rgba(250, 192, 59, 0.18), transparent 36%),
      linear-gradient(180deg, #ffffff 0%, #fff8ea 100%);
    background-position: center;
    background-size: cover;
  }

  @media (min-width: 901px) and (max-width: 1280px) {
    margin-bottom: 0;
    height: auto;
    min-height: 128px;
    padding: 72px 12px 8px;
  }
`;

export const PageHeaderBackdrop = styled.div`

  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background-color: #fff8ea;
  background-image:
    url(${HeaderBackground}),
    linear-gradient(90deg, #ffffff 0%, #fffaf0 100%);
  background-repeat: no-repeat, no-repeat;
  background-position:
    center calc(0px - 5vw),
    center;
  background-size: ${({ $compact }) =>
    $compact
      ? "calc(100% + 96px) auto, 100% 100%"
      : "calc(100% + 112px) auto, 100% 100%"};
  overflow: visible;
  box-shadow: ${({ $compact }) =>
    $compact ? "0 2px 10px rgba(0, 0, 0, 0.08)" : "none"};

  @media (max-width: 768px) {
    background-position: center top;
    background-size: calc(100% + 96px) auto;
  }

  @media (max-width: 900px) {
    background-color: #fff8ea;
    background-image:
      radial-gradient(circle at 72% 5%, rgba(250, 192, 59, 0.18), transparent 36%),
      linear-gradient(180deg, #ffffff 0%, #fff8ea 100%);
    background-position: center;
    background-size: cover;
  }
`;

export const HeaderLogoHomeButton = styled.button`
  position: absolute;
  left: ${({ $compact }) =>
    $compact ? "clamp(22px, 3vw, 48px)" : "clamp(24px, 2.4vw, 46px)"};
  top: ${({ $compact }) =>
    $compact ? "calc(50% - 14px)" : "calc(50% - 10.5px)"};
  width: ${({ $compact }) =>
    $compact ? "clamp(220px, 16vw, 280px)" : "clamp(240px, 15vw, 290px)"};
  height: ${({ $compact }) =>
    $compact ? "clamp(64px, 5vw, 88px)" : "clamp(76px, 6vw, 106px)"};
  border: 0;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  z-index: 8;
  padding: 0;
  display: block;
  transform: translateY(-50%);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: left center;
  }

  &:focus-visible {
    outline: 2px solid #005f5b;
    outline-offset: 4px;
  }

  @media (max-width: 1280px) {
    left: 24px;
    top: 36px;
    width: min(270px, 42vw);
    height: 56px;
  }

  @media (max-width: 640px) {
    left: 10px;
    top: 8px;
    width: 58vw;
    height: 48px;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

// Wraps the combined Swachh Bharat/Ministry of Minority Affairs logo so each
// half can carry its own click-through link (the image itself has one baked-in
// divider line splitting it roughly 46.6% / 53.4%).
export const HeaderPartnerLogoWrapper = styled.div`
  position: absolute;
  top: ${({ $compact }) =>
    $compact ? "calc(50% - 14px)" : "calc(50% - 10.5px)"};
  right: clamp(8px, 1.1vw, 22px);
  z-index: 8;
  display: inline-block;
  transform: translateY(-50%);

  img {
    display: block;
    width: ${({ $compact }) =>
      $compact ? "clamp(320px, 23vw, 400px)" : "clamp(360px, 27vw, 520px)"};
    height: auto;
    max-height: ${({ $compact }) => ($compact ? "72px" : "98px")};
    object-fit: contain;
  }

  @media (max-width: 1100px) {
    img {
      width: min(360px, 37vw);
    }
  }

  @media (min-width: 901px) and (max-width: 1280px) {
    top: 36px;

    img {
      width: min(278px, 31vw);
      max-height: 54px;
    }
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const PartnerLogoHitArea = styled.a`
  position: absolute;
  top: 0;
  height: 100%;
  display: block;
`;

export const SwachhBharatHitArea = styled(PartnerLogoHitArea)`
  left: 0;
  width: 46.6%;
`;

export const MinorityAffairsHitArea = styled(PartnerLogoHitArea)`
  right: 0;
  width: 53.4%;
`;

export const MobileBranding = styled.div`
  display: none;

  @media (max-width: 900px) {
    position: relative;
    flex: 1 1 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 54px;
    height: auto;
    z-index: 7;

    .mobile-brand-home {
      min-width: 0;
      max-width: 46%;
      border: 0;
      background: transparent;
      padding: 0;
      cursor: pointer;
    }

    .mobile-brand-home img {
      display: block;
      width: min(240px, 100%);
      height: auto;
    }

    .mobile-partner-logos {
      min-width: 0;
      max-width: 50%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: clamp(6px, 2vw, 14px);
    }

    .mobile-partner-logo-wrap {
      position: relative;
      display: inline-block;
      width: 92%;
      max-width: 92%;
    }

    .mobile-partner-logo-wrap img {
      display: block;
      width: 100%;
      height: auto;
      max-height: 38px;
      object-fit: contain;
    }
  }

  @media (max-width: 420px) {
    inset-inline: 8px;
    gap: 8px;

    .mobile-brand-home {
      max-width: 50%;
    }

    .mobile-partner-logos {
      max-width: 47%;
      gap: 5px;
    }

    .mobile-partner-logo-wrap img {
      max-height: 34px;
    }
  }
`;



export const NavPill = styled.div`
  width: auto;

  height: ${({ $compact }) => ($compact ? "58px" : "57px")};

  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  padding: ${({ $compact }) => ($compact ? "0 8px 0 22px" : "0 12px 0 24px")};

  background-color: #005f5b;
  background-image: linear-gradient(90deg, #005f5b 0%, #174586 100%);
  border-radius: 999px;

  position: absolute;
  bottom: ${({ $compact }) => ($compact ? "-30px" : "-36px")};
  left: clamp(16px, 1.55vw, 22px);
  right: clamp(16px, 1.55vw, 22px);
  transform: none;

  box-shadow: ${({ $compact }) =>
    $compact ? "0 6px 18px rgba(0, 0, 0, 0.16)" : "0 10px 30px rgba(0, 0, 0, 0.18)"};
  z-index: 10;
  overflow: visible;

  @media (min-width: 1281px) and (max-width: 1540px) {
    gap: 8px;
    padding: 0 10px 0 22px;
  }

  @media (max-width: 1280px) {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    width: 100%;
    min-height: 48px;
    height: auto;
    align-items: flex-start;
    gap: 6px;
    padding: 0 6px 0 14px;
    transform: none;
    border-radius: 20px;
  }

  @media (min-width: 1000px) and (max-width: 1280px) {
    align-items: center;
    min-height: 57px;
    padding: 0 8px 0 12px;
    border-radius: 999px;
  }

  @media (max-width: 900px) {
    left: auto;
    right: auto;
    width: 100%;
    padding: 0 6px 0 14px;
    border-radius: 20px;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    padding: 8px;
  }

`;
export const LoginPill = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: auto;
  height: ${({ $compact }) => ($compact ? "44px" : "54px")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  border-radius: 999px;
  z-index: 10;

  @media (max-width: 999px) {
    position: absolute;
    top: 4px;
    right: 6px;
    width: 108px;
    height: 40px;
  }
  @media (max-width: 480px) {
    position: relative;
    top: auto;
    right: auto;
    width: 100%;
    height: auto;
    padding-bottom: 4px;
  }

`;

export const LoginButton = styled.button`
  border-radius: 999px;
  background: white;
  color: #005f5b;
  font-weight: 600;
  font-size: ${({ $compact }) => ($compact ? "12px" : "13px")};
  min-height: ${({ $compact }) => ($compact ? "34px" : "40px")};
  padding: ${({ $compact }) => ($compact ? "0 16px" : "0 24px")};
  white-space: nowrap;

  @media (min-width: 1281px) and (max-width: 1540px) {
    padding: 0 20px;
    font-size: 13px;
  }

  @media (min-width: 1000px) and (max-width: 1280px) {
    padding: 0 14px;
    font-size: 11px;
  }

  @media (max-width: 999px) {
    min-height: 32px;
    padding: 0 10px;
    font-size: 11px;
  }
  @media (max-width: 480px) {
    white-space: normal;
    padding: 8px 12px;
    line-height: 1.4;
    height: auto;
  }

`;

export const LogoTitle = styled.div`
  margin-left: -18px;
`;

export const MenuWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  width: auto;

  @media (max-width: 899px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Menu = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ $compact }) => ($compact ? "clamp(20px, 2.2vw, 34px)" : "12px")};
  justify-content: space-between;
  width: 100%;

  @media (min-width: 1281px) and (max-width: 1540px) {
    gap: 4px;
  }

  ${({ $compact }) =>
    $compact &&
    `
      > .relative:not(:first-child):not(:last-child) button {
        padding-left: 16px;
        padding-right: 16px;
      }
    `}

  @media (min-width: 1000px) and (max-width: 1280px) {
    gap: 2px;

    > .relative > button {
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  @media (max-width: 999px) {
    display: ${({ $mobileOpen }) => ($mobileOpen ? "flex" : "none")};
    position: static;
    top: auto;
    left: auto;
    width: 100%;
    /* The header is in document flow here; let the page scroll the full menu. */
    max-height: none;
    overflow: visible;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    padding: 12px;
    border-radius: 16px;
    background-color: #005f5b;
    background-image: linear-gradient(135deg, #005f5b 0%, #174586 100%);
    box-shadow: 0 14px 32px rgba(0, 0, 0, 0.24);

    > .relative {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
    }
  }
`;

export const MobileMenuToggle = styled.button`
  display: none;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  @media (max-width: 999px) {
    display: inline-flex;
    min-height: 48px;
    padding-right: 114px;
    flex-shrink: 0;
  }
  @media (max-width: 480px) {
    padding-right: 0;
    flex-wrap: wrap;
  }

`;

export const NavButton = styled.button`
  height: ${({ $compact }) => ($compact ? "36px" : "48px")};
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $compact }) => ($compact ? "5px" : "8px")};
  border: 1px solid ${({ $active, $compact }) =>
    !$compact && $active ? "rgba(255, 255, 255, 0.86)" : "transparent"};
  border-radius: 999px;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  font-size: ${({ $compact }) => ($compact ? "12px" : "14px")};
  font-weight: ${({ $compact }) => ($compact ? "600" : "500")};
  line-height: 1;
  padding: ${({ $compact }) => ($compact ? "0 8px" : "0 14px")};
  white-space: nowrap;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover,
  &:focus {
    border-color: ${({ $compact }) =>
      $compact ? "transparent" : "rgba(255, 255, 255, 0.68)"};
    background: transparent;
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.9);
    outline-offset: 2px;
  }

  @media (min-width: 1000px) and (max-width: 1280px) {
    gap: 4px;
    font-size: 11px;
    font-weight: 600;

    svg {
      width: 11px;
      height: 11px;
      flex-shrink: 0;
    }
  }

  @media (max-width: 999px) {
    &:focus-visible {
      outline: 2px solid #ffffff;
      outline-offset: 2px;
    }
  }

  @media (min-width: 1281px) and (max-width: 1540px) {
    gap: 5px;
    padding: 0 10px;
    font-size: 13px;
  }

  @media (max-width: 999px) {
    width: 100%;
    min-height: 40px;
    height: auto;
    justify-content: space-between;
    border-radius: 10px;
    padding: 10px 12px;
    white-space: normal;
    text-align: left;
  }
`;

export const Dropdown = styled.div`
  /* Submenu content remains readable when stylesheets are disabled. */
  display: ${({ $open }) => ($open ? "block" : "none")};
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.12);
  padding: 10px 0;
  min-width: 290px;
  max-width: min(420px, calc(100vw - 32px));
  z-index: 21000;

  &::before {
    content: "";
    position: absolute;
    top: -12px;
    left: 0;
    width: 100%;
    height: 12px;
  }

  @media (max-width: 999px) {
    position: static;
    width: 100%;
    min-width: 0;
    max-width: none;
    max-height: none;
    margin: 2px 0 8px;
    box-shadow: none;
    background: #ffffff;
    border-radius: 8px;

    &::before {
      display: none;
    }
  }
`;

export const DropdownItem = styled.div`
  padding: 8px 20px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #edf4f8;
  }

  a {
    display: block;
    color: #0b5d82;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: #083f5c;
    }
  }

  button {
    color: #0b5d82;

    &:focus-visible {
      outline: 2px solid #005f5b;
      outline-offset: 2px;
      border-radius: 4px;
    }
  }

  @media (max-width: 999px) {
    padding: 10px 16px;

    a, button {
      font-size: 14px;
    }
  }
`;

export const Divider = styled.div`
  width: 1px;
  flex-shrink: 0;
  height: ${({ $compact }) => ($compact ? "28px" : "38px")};
  background: rgba(255, 255, 255, 0.24);
  display: ${({ $compact }) => ($compact ? "none" : "block")};

  @media (max-width: 999px) {
    display: none;
  }
`;
